<template>
  <div class="typed-on-paper-tabs-padding">

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Ranks'}">-->
<!--      <div class="heading">Teams</div>-->
<!--    </DivLinkButton>-->

    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Ranks'}">
      <div class="heading">Ranks</div>
    </DivLinkButton>

  </div>
</template>

<script>
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"

export default {
  name: "StructureSideNav",
  components: {
    DivLinkButton,
    HideableDiv
  },
  methods: {

    navigate_to: function (link) {

      location.replace(link);
    }
  }

}
</script>

<style scoped>

.subcontent-buttons{
  font-size: 1em;
  margin: 2px 0px 0px 15px;
  width: calc(100% - 15px - 26px);
}

</style>



// WEBPACK FOOTER //
// src/components/info/StructureSideNav.vue